import {
  View,
  Text,
  TextStyle,
  ViewStyle,
  ImageStyle,
  Image,
} from 'react-native';
import React from 'react';
import {corner_radius, spacing} from 'theme/Units';

type baseStyleProps = {
  card?: ViewStyle;
  title?: TextStyle;
  description?: TextStyle;
  quote?: ImageStyle;
};

const BASE: baseStyleProps = {
  card: {
    padding: spacing['6'],
    borderRadius: corner_radius['rounded-md'],
    gap: spacing['4'],
    width: 350,
    height: '100%',
  },
  title: {
    fontSize: 24,
    fontWeight: '700',
  },
  description: {
    fontSize: 16,
    fontWeight: '500',
  },
  quote: {
    width: 18,
    height: 13,
    resizeMode: 'contain',
  },
};

type variantsType = {
  active: baseStyleProps;
  unactive: baseStyleProps;
};

const variants: variantsType = {
  active: {
    card: {
      ...BASE.card,
      backgroundImage:
        'linear-gradient(to bottom right, #7366FF 0%, #B961FF 100%)',
    },
    description: {
      ...BASE.description,
      color: 'white',
    },
    title: {
      ...BASE.title,
      color: 'white',
    },
    quote: {
      ...BASE.quote,
    },
  },
  unactive: {
    card: {...BASE.card, backgroundColor: 'white'},
    description: {
      ...BASE.description,
      color: 'black',
    },
    title: {
      ...BASE.title,
      color: 'black',
    },
    quote: {
      ...BASE.quote,
    },
  },
};

type cardPropsType = Readonly<{
  title?: string;
  description?: string;
  variant?: keyof typeof variants;
  style?: ViewStyle;
}>;

export function TestmonialCard(props: cardPropsType): JSX.Element {
  const {description, title, variant = 'unactive', style} = props;
  const styles = variants[variant] || variants.unactive;


  const blackQoute = (
    <Image
      style={styles.quote}
      source={require('assets/icons/quote@2x.png')}
    />
  );
  const whiteQoute = (
    <Image
      style={styles.quote}
      source={require('assets/icons/quote_white@2x.png')}
    />
  );

  return (
    <View style={[styles.card, style]}>
      {variant === 'active' ? whiteQoute : blackQoute}
      <Text style={styles.title}>{title}</Text>
      <Text style={styles.description}>{description}</Text>
    </View>
  );
}
